// Override do LINK do botão FLUTUANTE (FAB) de WhatsApp, por site — rastreio de cliques via
// um redirecionador externo (ex.: tintim.link, p/ UTM). Ticket #843 / #664 (cs 2451 unioimoveis).
//
// ⚠️ Diferente de utils/site2524WhatsApp.ts, que troca TODOS os links de WhatsApp do site
// (topo, botões de imóvel, chat): AQUI é SÓ o FAB flutuante. Os botões de WhatsApp dos
// IMÓVEIS continuam wa.me com a mensagem contextual (ref do imóvel) intacta.
const FLOATING_WHATS_HREF: Record<string, string> = {
    // cs 2451 removido em 18/08 (ticket #1170): cliente deixou o Tintim — FAB volta ao wa.me padrão.
};

export const getFloatingWhatsHref = (site: any): string | null =>
    FLOATING_WHATS_HREF[String(site?.id)] ?? null;
